"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveTreeOrThrow = moveTreeOrThrow;
const path = __importStar(require("path"));
const fsExtra = __importStar(require("fs-extra"));
/**
 * Move a file/dir tree with an **atomic-or-fail-loud** guarantee: after this
 * resolves, `source` is gone and only `dest` exists — or it throws and the tree
 * is left exactly as it was (no duplicate).
 *
 * Why this exists: fs-extra's `move` renames when it can, but falls back to
 * copy-then-remove when a plain rename isn't possible (cross-device, or — on
 * Windows — a file under `source` held open by an editor/handle). If the
 * post-copy removal of `source` fails, the copy has *already* landed, leaving a
 * silent duplicate (two copies of the same thread → duplicate ULIDs, doubled
 * roadmap/link-index counts). A caller that used raw `fs.move` had no way to
 * tell that half-move apart from success.
 *
 * Guarantee here: if `source` survives (whether `move` threw or resolved), we
 * roll back the copy we just made and throw an actionable error. We only remove
 * `dest` when *we* created it — a pre-existing `dest` is never touched.
 */
async function moveTreeOrThrow(source, dest, fs = fsExtra) {
    const destPreexisted = await fs.pathExists(dest);
    // Roll back only the copy we made; never clobber a dest that was already there.
    const rollback = async () => {
        if (!destPreexisted)
            await fs.remove(dest).catch(() => { });
    };
    await fs.ensureDir(path.dirname(dest));
    try {
        await fs.move(source, dest, { overwrite: false });
    }
    catch (err) {
        // move may have copied `dest` before failing to remove `source`.
        await rollback();
        throw new Error(`Move failed for "${source}" → "${dest}": ${err.message}. ` +
            `A file there is likely open or locked — close any editors holding these ` +
            `docs and retry. No changes were kept.`);
    }
    // Defensive: even a resolved `move` can leave `source` behind on some
    // copy-fallback paths. Verify, and if so roll back so we never duplicate.
    if (await fs.pathExists(source)) {
        await rollback();
        throw new Error(`Move incomplete: source still present at "${source}" after the move — a file ` +
            `there is likely open or locked. Close any editors holding these docs and retry. ` +
            `No changes were kept.`);
    }
}
